import React from "react";
import { ImgV2 } from "../../../ImgV2";
export const SmallAwardCard = ({ leftLeavesImage, rightLeavesImage, title, subtitle, date }) => (React.createElement("div", { className: "small-award-card" },
    React.createElement("div", { className: "small-award-card__award-wrapper" },
        React.createElement(ImgV2, { src: leftLeavesImage, alt: "" }),
        React.createElement("p", { className: "small-award-card__award-wrapper__title" }, title),
        React.createElement(ImgV2, { src: rightLeavesImage, alt: "" })),
    React.createElement("p", { className: "small-award-card__subtitle" }, subtitle),
    React.createElement("p", { className: "small-award-card__date" }, date)));
